export const rankingList = [
  {
    id: 'live-slip-01',
    title: '直播翻车名场面：一句话让整屏弹幕笑到打鸣',
    category: '名场面',
    today: 128400,
    week: 742000,
    month: 2310000,
    trend: 'up',
  },
  {
    id: 'variety-catch-meme-02',
    title: '综艺接梗天花板：主持人当场破防',
    category: '接梗合集',
    today: 96400,
    week: 518000,
    month: 1420000,
    trend: 'up',
  },
  {
    id: 'danmaku-overrun-04',
    title: '弹幕被彻底玩坏：评论区集体失语',
    category: '弹幕玩梗',
    today: 88900,
    week: 476000,
    month: 1180000,
    trend: 'same',
  },
  {
    id: 'group-emoji-war-03',
    title: '群聊高能：一个表情包引发刷屏大战',
    category: '群聊高能',
    today: 74200,
    week: 398000,
    month: 965000,
    trend: 'up',
  },
  {
    id: 'top-comment-show-05',
    title: '热评第一永远在整活：评论区比正文精彩',
    category: '热评现场',
    today: 61500,
    week: 332000,
    month: 874000,
    trend: 'down',
  },
  {
    id: 'meme-chain-06',
    title: '玩梗现场：全网都在接这一句',
    category: '接梗合集',
    today: 55300,
    week: 287000,
    month: 712000,
    trend: 'same',
  },
  {
    id: 'scene-review-07',
    title: '名场面复盘：从玩梗到出圈只用了三天',
    category: '名场面',
    today: 49800,
    week: 251000,
    month: 638000,
    trend: 'up',
  },
  {
    id: 'social-death-08',
    title: '社死瞬间名场面：当事人还在解释',
    category: '热评现场',
    today: 43200,
    week: 226000,
    month: 549000,
    trend: 'down',
  },
];